// import { Intl } from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { BooleanFilters } from './BooleanFilters';
import { ListAccordion } from './Mobile/ListAccordion';
import { RangeAccordion } from './Mobile/RangeAccordion';
// import { SortOrderAccordion } from './Mobile/SortOrderAccordion';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { ClearButton } from './ActiveFilters';
import t from '@jetshop/intl';
import Button from '../../ui/Button';
import { theme } from '../../Theme';

const Title = styled('h1')`
  color: black;
  font-size: 1.125rem;
  text-align: left;
  padding-bottom: 10px;
  font-weight: 600;
  text-transform: uppercase;
`;

const Wrapper = styled('div')`
  overflow-x: scroll;
  padding-right: 20px;
  margin-right: -20px;
  button {
    padding: 0 1rem;
    border-width: 1px 0 0 0;
  }
`;

const ButtonContainer = styled('div')`
  padding: 30px 0;
  margin-bottom: 20px;
  height: 100%;
  button {
    width: 100%;
  }
`;

const boolFilters = css`
  padding: 1rem;
  label {
    margin-top: 0.5em;
  }
`;

const ApplyButton = styled(Button)`
  width: 100%;
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  text-decoration: none;
  background: ${theme.colors.blackish};
  color: white;
  border-radius: 44px;
  border: 0;
  font-family: ${theme.fonts.primary};
  font-weight: 500;

  :hover {
    opacity: 0.9;
  }
`;

const FilterWrapper = styled('div')`
  max-height: 92vh;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const FilterDrawer = ({ filters, sortOrders, close, ...props }) => {
  const { clearAllFilters } = useFilters();
  const isActiveListFilter = filters.some(listFilter => {
    return listFilter.hasActiveItems;
  });

  const listFilters = (filters || []).filter(
    filter => filter.__typename === 'ListFilter'
  );

  const rangeFilters = (filters || []).filter(
    filter => filter.__typename === 'NumericRangeFilter'
  );

  const isFilters = !!filters;
  const isSortOrders = sortOrders.length > 0;

  return (
    <section {...props}>
      {(isFilters || isSortOrders) && (
        <FilterWrapper>
          <Wrapper>
            <Title>{t('Filter')}</Title>
            <Accordion single>
              {accordionProps => (
                <>
                  {isFilters && (
                    <>
                      <ListAccordion
                        filters={filters}
                        accordionProps={accordionProps}
                      />
                      <RangeAccordion
                        filters={filters}
                        accordionProps={accordionProps}
                        startingIdx={listFilters.length}
                      />
                    </>
                  )}
                  {/* {isSortOrders && (
                    <SortOrderAccordion
                      sortOrders={sortOrders}
                      accordionProps={accordionProps}
                      startingIdx={listFilters.length + rangeFilters.length}
                    />
                  )} */}
                  {isFilters && (
                    <div className={boolFilters}>
                      <BooleanFilters filters={filters} />
                    </div>
                  )}
                </>
              )}
            </Accordion>
          </Wrapper>

          <ButtonContainer>
            <ApplyButton onClick={close}>{t('Apply filters')}</ApplyButton>
            {isActiveListFilter && (
              <ClearButton type="button" onClick={clearAllFilters}>
                {t('Clear all filters')}
              </ClearButton>
            )}
          </ButtonContainer>
        </FilterWrapper>
      )}
    </section>
  );
};
export default FilterDrawer;
